import { useCallback } from "react";
import { resetGeometryEditor } from "ducks/geometryEditor/geometryEditor";
import { resetMouseLabel } from "ducks/mouseLabel/mouseLabel";
import { useDispatch } from "react-redux";

export const useResetGeometryEditor = (): VoidFunction => {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(resetGeometryEditor());
    dispatch(resetMouseLabel());
  }, [dispatch]);
};
